import tippy, { delegate } from 'tippy.js';

$(window).on('turbolinks:load', function () {
  delegate(document.body, {
    theme: 'tooltip',
    target: '.js-tippyTooltip-button',
    content: (reference) => {
      return reference.nextElementSibling?.innerHTML;
    },
    allowHTML: true,
    interactive: true,
    trigger: 'mouseenter click',
    placement: 'bottom',
    arrow: true,
    duration: [0, 0],
    appendTo: document.body,
    zIndex: 9999,
  });

  delegate(document.body, {
    target: '.js-table-list-sortable',
    content: (reference) => {
      return reference.querySelector('.js-table-list-sortable-dropdown')?.innerHTML;
    },
    allowHTML: true,
    interactive: true,
    trigger: 'mouseenter click',
    placement: 'bottom',
    offset: [0, 3],
    duration: [0, 0],
    appendTo: document.body,
    zIndex: 9999,
    arrow: false,
  });

  if ($('.js-input-meetingTopicSelect').length > 0) {
    delegate(document.body, {
      theme: 'meetingTopicSelect',
      target: '.js-input-meetingTopicSelect-trigger',
      content: (reference) => {
        const parent = reference.closest('.js-input-meetingTopicSelect');
        const dropdown = parent?.querySelector('.js-input-meetingTopicSelect-dropdown');
        if (dropdown) {
          dropdown.style.display = '';
          dropdown._meetingTopicSelectTrigger = reference;
        }
        return dropdown;
      },
      interactive: true,
      trigger: 'click',
      placement: 'bottom',
      offset: [0, 3],
      duration: [0, 0],
      appendTo: document.body,
      zIndex: 9999,
      arrow: false,
    });

    $(document.body).off('click.meetingTopicSelect').on('click.meetingTopicSelect', '.js-input-meetingTopicSelect-dropdown [role="option"]', function () {
      const li = this;
      const value = li.dataset.value;
      const text = li.textContent.trim();
      const bgColor = li.style.backgroundColor;

      const dropdown = li.closest('.js-input-meetingTopicSelect-dropdown');
      const trigger = dropdown?._meetingTopicSelectTrigger;
      if (!trigger) return;

      const parent = trigger.closest('.js-input-meetingTopicSelect');
      const hiddenInput = parent?.querySelector('input[type="hidden"][name="category"]');
      if (hiddenInput) {
        hiddenInput.value = value;
        hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      const labelSpan = trigger.querySelector('span');
      if (labelSpan) labelSpan.textContent = text;
      trigger.style.backgroundColor = bgColor;
      trigger.style.color = '#fff';

      if (trigger._tippy) trigger._tippy.hide();
    });
  }
});

$(window).on('turbolinks:load', function () {
  for (const companyMypageProgressList of document.querySelectorAll('.js-companyMypageProgress-list')) {
    const step = parseInt(companyMypageProgressList.dataset.step, 10);
    const points = Array.from(companyMypageProgressList.querySelectorAll('[class$="-point"]'));
    const lines = Array.from(companyMypageProgressList.querySelectorAll('[class$="-line"]'));

    const activePoints = points.slice(0, step);
    const activeLines = lines.slice(0, step);

    setTimeout(() => {
      activePoints.forEach((point, index) => {
        setTimeout(() => {
          point.classList.add('isActive');
        }, index * 700);
      });
      activeLines.forEach((line, index) => {
        setTimeout(() => {
          line.classList.add('isActive');
        }, index * 700);
      });
    }, 500);
  }
});

$(window).on('turbolinks:load', function () {
  const tabContainer = document.querySelector('.js-karteTab');
  if (!tabContainer) return;

  // タブのキー（= 各 li の class）。URL の ?tab= の値とも対応する
  const KARTE_TAB_KEYS = ['basic', 'one_on_one', 'managing', 'how_to', 'alert', 'for_individual'];
  const tabItems = Array.from(tabContainer.querySelectorAll('li'));
  const panels = Array.from(document.querySelectorAll('.js-karteTab-panel'));

  const keyOfTab = (li) => KARTE_TAB_KEYS.find((key) => li.classList.contains(key));

  // レポート本文の入れ物です。初回アクセス時に AJAX で本文を読み込みます。
  const reportContainer = document.querySelector('.js-karteReport');
  const panelOf = (key) => panels.find((panel) => panel.dataset.tab === key);

  // レポート上部の見出し（h1 内の span）。アクティブタブの li の data-heading に差し替える。
  const titleEl = document.querySelector('.js-karteTitle');

  // 指定タブの本文をサーバから取得して差し込みます（本文はAI生成パイプラインがS3に書き出した output が供給元）。
  // 一度読み込んだタブ（data-loaded="true"）や読み込み中（"loading"）は再取得しません。
  const loadKartePanel = (key) => {
    if (!reportContainer) return;
    const panel = panelOf(key);
    if (!panel) return;
    if (panel.dataset.loaded === 'true' || panel.dataset.loaded === 'loading') return;

    panel.dataset.loaded = 'loading';

    const url = new URL(reportContainer.dataset.url, window.location.origin);
    url.searchParams.set('assessment_id', reportContainer.dataset.assessmentId);
    url.searchParams.set('category', key);

    fetch(url.toString(), {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then((res) => res.json().then((json) => ({ ok: res.ok, json })))
      .then((result) => {
        if (result.ok && result.json && result.json.html) {
          panel.innerHTML = result.json.html;
          panel.dataset.loaded = 'true';
        } else {
          panel.dataset.loaded = 'false'; // 次回アクセス時に再試行できるよう戻します
        }
      })
      .catch(() => {
        panel.dataset.loaded = 'false';
      });
  };

  // タブがアクティブになるたびに呼ばれる関数（クリック時・タブURLで入ってきた時の両方）
  const onKarteTabActivate = (key) => {
    loadKartePanel(key);
  }

  const activateKarteTab = (key, { updateUrl = true } = {}) => {
    // 不正・未指定のキーは先頭タブにフォールバック
    if (!KARTE_TAB_KEYS.includes(key)) {
      key = KARTE_TAB_KEYS[0];
    }

    // アクティブな li に act クラスを付与
    tabItems.forEach((li) => {
      li.classList.toggle('act', keyOfTab(li) === key);
    });

    // 対応するコンテンツだけ表示
    panels.forEach((panel) => {
      panel.style.display = panel.dataset.tab === key ? '' : 'none';
    });

    // レポート見出しをアクティブタブの文言に差し替える
    const activeLi = tabItems.find((li) => keyOfTab(li) === key);
    if (titleEl && activeLi && activeLi.dataset.heading) {
      titleEl.textContent = activeLi.dataset.heading;
    }

    // ページ遷移せず URL にだけ反映
    if (updateUrl) {
      const url = new URL(window.location.href);
      url.searchParams.set('tab', key);
      window.history.replaceState({}, '', url);
    }

    onKarteTabActivate(key);
  }

  tabContainer.addEventListener('click', (e) => {
    const li = e.target.closest('li');
    if (!li || !tabContainer.contains(li)) return;
    const key = keyOfTab(li);
    if (!key) return;
    e.preventDefault();
    activateKarteTab(key);
  });

  // タブURLで入ってきた場合はそのタブを、無ければ先頭タブをアクティブにする
  const initialKey = new URL(window.location.href).searchParams.get('tab');
  activateKarteTab(initialKey, { updateUrl: false });
});

$(window).on('turbolinks:load', function () {
  for (const button of document.querySelectorAll('.js-companyMypageProgress-videoButton')) {
    button.addEventListener('click', (e) => {
      const body = document.querySelector(`.js-companyMypageProgress-videoBody[data-key="${button.dataset.key}"]`);
      $(body).slideToggle();
    });
  }
});
